"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _MenuSearch = _interopRequireDefault(require("@/components/MenuSearch"));
var _validate = require("@/utils/validate");
var _i18n = require("@/utils/i18n");
var _nav_bg = _interopRequireDefault(require("@/assets/img/nav_bg.png"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TopMenu',
  components: {
    Search: _MenuSearch.default
  },
  props: {},
  data: function data() {
    return {
      currentUrl: '',
      viewW: '',
      scrollLeft: '',
      scrollWidth: '',
      menuListW: '',
      currentUrlMatched: '',
      bgImg: {
        backgroundImage: "url(".concat(_nav_bg.default, ")"),
        backgroundSize: '100% 100%',
        backgroundRepeat: 'repeat-x'
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebar', 'language'])), {}, {
    menuList: function menuList() {
      console.log('this.$store.state.permission.addRoutes', this.$store.state.permission.addRoutes);
      debugger;
      return this.$store.state.permission.addRoutes;
    },
    isShowLeft: function isShowLeft() {
      return this.scrollLeft !== 0;
    },
    isShowRight: function isShowRight() {
      var isShow = false;
      if (this.scrollWidth === this.menuListW && this.scrollLeft < this.menuListW - this.viewW - 1) {
        isShow = true;
      }
      return isShow;
    }
  }),
  watch: {
    $route: {
      handler: function handler(val) {
        this.currentUrl = val.path;
        this.currentUrlMatched = val.matched ? val.matched[0].path : val.path;
      },
      // 深度观察监听
      deep: true
    },
    language: function language() {
      var _this = this;
      this.$nextTick(function () {
        _this.getScroll();
        _this.menuListW = _this.$refs['menuList'].clientWidth;
      });
    }
  },
  created: function created() {
    this.currentUrl = this.$route.path;
    this.currentUrlMatched = this.$route.matched ? this.$route.matched[0].path : this.$router.path;
  },
  mounted: function mounted() {
    var that = this;
    this.$nextTick(function () {
      that.getScroll();
      that.menuListW = this.$refs['menuList'].clientWidth;
      window.addEventListener('resize', that.getScroll);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.getScroll);
  },
  methods: {
    /* 获取滚动条信息 */getScroll: function getScroll() {
      // console.log(this.$refs['topScroll'])
      this.viewW = this.$refs['topScroll'].wrap.offsetParent.clientWidth;
      this.scrollLeft = this.$refs['topScroll'].wrap.scrollLeft;
      this.scrollWidth = this.$refs['topScroll'].wrap.scrollWidth;
    },
    resolvePath: function resolvePath(routePath) {
      return (0, _validate.isExternal)(routePath);
    },
    generateTitle: _i18n.generateTitle,
    /* 左移 */handleScrollLeft: function handleScrollLeft() {
      var scrollLeft = this.$refs['topScroll'].wrap.scrollLeft;
      if (scrollLeft <= this.menuListW) {
        // this.$refs['topScroll'].wrap.scrollLeft = scrollLeft - 30
        this.$refs['topScroll'].wrap.scrollLeft = 0;
      }
      this.getScroll();
    },
    /* 右移 */handleScrollRight: function handleScrollRight() {
      var scrollLeft = this.$refs['topScroll'].wrap.scrollLeft;
      if (scrollLeft < this.menuListW) {
        // this.$refs['topScroll'].wrap.scrollLeft = scrollLeft + 30
        this.$refs['topScroll'].wrap.scrollLeft = this.menuListW;
      }
      this.getScroll();
    } // handmouseMove() {
    //   console.log(1)
    // }
  }
};